




import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateRouteItem } from "../../../../../features/updateLoad/updateLoadSlice"
import { useEffect } from "react"

const Container = styled.div`
    width: 500px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    textarea{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        resize: vertical;
        min-height: 40px;
        max-height: 140px;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    textarea:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        top: 14px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YuklemeAdresTarifiInput = ({data, name, isRequired}) => {

    const [text, setText] = useState(data?.adresTarif)

    const dispatch = useDispatch()

    useEffect(()=> {
        setText(data.adresTarif)
    },[data.adresTarif])

    const handleChange = (e) => {
        setText(e.target.value)

        const updatedItem = {
            id: data.id,
            adresTarif: e.target.value
        }
        
        dispatch(updateRouteItem(updatedItem))
    }

    
  return (
    <Container value={text} radius={"5px"}>
        <textarea  id={"text"} onChange={handleChange} value={text} name={name}/> 
        <label htmlFor={"text"}>Adres Tarifi</label>
    </Container>
  )
}

export default YuklemeAdresTarifiInput